import React from 'react';
import DefaultContainer from '../../components/DefaultContainer';
import { Button, Text } from '~/components';
import { Components } from '~/scenes/HiredInsurance/components';
import useAppNavigation from '~/hooks/useAppNavigation';

const HiredInsuranceCancelSuccessIncomeProtection: React.FC = () => {
  const { navigate } = useAppNavigation();

  return (
    <DefaultContainer
      type="bag-protection"
      className="items-center justify-center pt-10 pb-16"
      showBanner={false}
    >
      <Text className="text-[22px] text-gray-700 text-center">
        Proteção Perda de Renda
      </Text>

      <Components.CancelStatus type="success" />

      <Text className="text-center text-gray-700 text-lg">
        Cancelamento realizado com sucesso!
      </Text>

      <Text className="mt-[22px] mb-[38px] text-sm text-gray-400 text-center">
        Espero que possamos ter você de volta em breve. Te esperamos!
      </Text>

      <Button
        className="w-full"
        onPress={() => navigate('MarisaServicos_Home')}
      >
        Voltar para a home marisa serviços
      </Button>
    </DefaultContainer>
  );
};

export default HiredInsuranceCancelSuccessIncomeProtection;
